import { CookieConsent } from "@trustpilot/businessapp-browserstorage";
import { useEffect, useState } from "react";

const trackingConsent = "C0002";
const functionalConsent = "C0003";

const hasCookieConsent = async () => {
  const consents = await Promise.all([
    CookieConsent.hasCategoryConsent(trackingConsent),
    CookieConsent.hasCategoryConsent(functionalConsent),
  ]);

  return consents.every(Boolean);
};

export const useHasCookieConsent = () => {
  const [hasConsent, setHasConsent] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    hasCookieConsent().then((result) => {
      if (isMounted) {
        setHasConsent(result);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return hasConsent;
};

export default useHasCookieConsent;
